/**
 * Relative time formatting utilities
 */

export function formatRelativeTime(
  isoTimestamp: string | null | undefined,
  now: Date = new Date()
): string {
  if (!isoTimestamp) return 'recently';

  const date = new Date(isoTimestamp);
  if (Number.isNaN(date.getTime())) return 'recently';

  const diffMs = now.getTime() - date.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);

  if (diffSeconds <= 0) return 'just now';
  if (diffSeconds < 45) return 'just now';
  if (diffSeconds < 90) return '1 minute ago';

  const minutes = Math.floor(diffSeconds / 60);
  if (minutes < 60) return `${minutes} minutes ago`;
  if (minutes < 90) return '1 hour ago';

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hours ago`;
  if (hours < 42) return '1 day ago';

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} days ago`;
  if (days < 45) return '1 month ago';

  const months = Math.floor(days / 30);
  if (months < 12) return `${months} months ago`;
  if (months < 18) return '1 year ago';

  const years = Math.floor(months / 12);
  return `${years} years ago`;
}